export const CITATION_WRAPPER_ATTRIBUTE = {
  'data-citation-wrapper': 'true',
};
